import React from "react";
import { PostCategory } from "../../types/post";

interface CategoryManagerProps {
  categories: PostCategory[];
  onDeleteCategory: (id: string) => Promise<void>;
  onEditCategory: (category: PostCategory) => void;
}

export const CategoryManager: React.FC<CategoryManagerProps> = ({
  categories,
  onDeleteCategory,
  onEditCategory,
}) => {
  return (
    <div className="mb-6 p-4 bg-gray-50 rounded-lg">
      <h3 className="m-0 mb-4">Kategorie ({categories.length})</h3>
      <div className="flex flex-wrap gap-2">
        {categories.map((category) => (
          <div
            key={category.id}
            className="flex items-center gap-2 px-3 py-1 bg-white border border-gray-200 rounded-2xl text-sm hover:shadow-sm transition-shadow"
          >
            <span className="flex-1">{category.name}</span>
            {category.group_key && (
              <span className="text-xs text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded">
                {category.group_key}
              </span>
            )}
            <button
              onClick={() => onEditCategory(category)}
              className="bg-transparent border-0 text-blue-500 cursor-pointer text-xs p-0.5 hover:text-blue-600 transition-colors"
              title="Edytuj kategorię"
            >
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
              </svg>
            </button>
            <button
              onClick={() => onDeleteCategory(category.id)}
              className="bg-transparent border-0 text-red-500 cursor-pointer text-xs p-0.5 hover:text-red-600 transition-colors"
              title="Usuń kategorię"
            >
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
